import { Machine } from "./Machine";

export class MachineData {

    iddata: number;
    quality: number;
    co2: number;
    pm10: number;
    temperature: number;
    humidity: number;
    datetime: Date;
    machine: Machine;

    constructor() {
        this.iddata = 0
        this.quality = 0
        this.co2 = 0
        this.pm10 = 0
        this.temperature = 0
        this.humidity = 0
        this.datetime = new Date()
        this.machine = new Machine()

    }
}